module.exports = __webpack_public_path__ + "static/img/jared_headshot.ea06f08.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jared_headshot.png
// module id = 9+tu
// module chunks = 1